export const PROVIDER_ROLES = [
  { value: '0', title: 'Counsellor' },
  { value: '1', title: 'Psychotherapist' },
  { value: '2', title: 'Psychiatrist' },
  { value: '3', title: 'Student' },
  { value: '4', title: 'Other' }
];



// WEBPACK FOOTER //
// ./src/constants/provider_roles.js